export enum DeliveryOrderMarkerType {
    COURIER = 'courier',
    DROPOFF = 'dropoff',
    LOCATION = 'location',
    NAVIGATION_PATH = 'navigation_path'
}
